import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { getAccessToken } from 'src/Redux/auth-process/credentialsSlice/selectors'
import { sendSourceBusterEvent } from 'src/Redux/sourcebuster-process/api-actions'
import { getCookieByName, getUtmParameters } from 'src/Constants/functions'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

export const useSourceBusterEvent = (): {
  sendCreateBasicCampaignSourceBusterEvent: (
    campaignId: number,
    campaignPlatform: CampaignPlatformTypeEnum,
  ) => void
  sendCreateFirstCampaignSourceBusterEvent: (
    campaignId: number,
    campaignPlatform: CampaignPlatformTypeEnum,
    customToken?: string,
  ) => void
} => {
  const dispatch = useAppDispatch()
  const token = useAppSelector(getAccessToken)

  const sendCreateBasicCampaignSourceBusterEvent = useCallback(
    (campaignId: number, campaignPlatform: CampaignPlatformTypeEnum): void => {
      const utmObj = getUtmParameters(getCookieByName('soundCampaignUtm'))

      void dispatch(
        sendSourceBusterEvent({
          token,
          campaignPlatform,
          campaignId,
          eventName: 'create_basic_campaign',
          gclid: utmObj.gclid || '',
        }),
      )
    },
    [dispatch, token],
  )

  const sendCreateFirstCampaignSourceBusterEvent = useCallback(
    (
      campaignId: number,
      campaignPlatform: CampaignPlatformTypeEnum,
      customToken?: string,
    ): void => {
      const utmObj = getUtmParameters(getCookieByName('soundCampaignUtm'))

      void dispatch(
        sendSourceBusterEvent({
          campaignPlatform,
          campaignId,
          token: customToken || token,
          eventName: 'create_first_campaign',
          gclid: utmObj.gclid || '',
        }),
      )
    },
    [dispatch, token],
  )

  return {
    sendCreateBasicCampaignSourceBusterEvent,
    sendCreateFirstCampaignSourceBusterEvent,
  }
}
